import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { REFETCH_INTERVAL } from "@/lib/constants";
import { Document } from "@/types/document";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

export async function getGitDocumentById(
  docId: number,
  headers: Record<string, string>
): Promise<{ data: Document }> {
  const url = `${config.isometricApiUrl}/documents/${docId}`;

  const response = await apiFetch(url, {
    headers: {
      ...headers,
    },
  });

  // Check if the response is ok (status code in the range 200-299)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = await response.json();
  return result;
}
export default function useGetGitDocumentService(
  docId?: number,
  enabled?: boolean,
  refetch: boolean = true
) {
  const { getAuthHeaders } = useAuthHeaders();
  
  return useQuery({
    queryKey: ["git-document-by-id", docId],
    queryFn: () => {
      if (!docId) throw new Error('Document ID is required');
      const headers = getAuthHeaders();
      return getGitDocumentById(docId, headers);
    },
    enabled: !!enabled && !!docId,
    refetchInterval: refetch ? REFETCH_INTERVAL : false,
  });
}
